import PulseNavbar from '../components/pulse/PulseNavbar';
import Hero from '../components/pulse/Hero';
import ProblemSolution from '../components/pulse/ProblemSolution';
import FeaturesSection from '../components/pulse/FeaturesSection';
import HowItWorks from '../components/pulse/HowItWorks';
import Personalization from '../components/pulse/Personalization';
import Integrations from '../components/pulse/Integrations';
import Testimonials from '../components/pulse/Testimonials';
import Pricing from '../components/pulse/Pricing';
import FAQ from '../components/pulse/FAQ';
import FinalCTA from '../components/pulse/FinalCTA';
import PulseFooter from '../components/pulse/PulseFooter';

export default function Pulse() {
  return (
    <div className="dark-scrollbar" style={{ background: '#0f172a', color: '#e2e8f0', minHeight: '100vh', fontFamily: 'Inter, system-ui, sans-serif' }}>
      <PulseNavbar />
      <Hero />
      <ProblemSolution />
      <FeaturesSection />
      <HowItWorks />
      <Personalization />
      {/* Integrations will be added later */}
      {/* Testimonials will be added later */}
      <Pricing />
      <FinalCTA />
      {/* FAQ will be added later */}
      <PulseFooter />
    </div>
  );
}
